module.exports = __webpack_public_path__ + "img/5.0e977766.png";